import { render, staticRenderFns } from "./ExplorePerfumes.vue?vue&type=template&id=2448cb98"
import script from "./ExplorePerfumes.vue?vue&type=script&lang=js"
export * from "./ExplorePerfumes.vue?vue&type=script&lang=js"
import style0 from "./ExplorePerfumes.vue?vue&type=style&index=0&id=2448cb98&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports